<template>
    <w-tabs
        class="mt3"
        :items="resultTabs"
        :no-slider="false"
        v-model="activeTab"
        active-class="primary"
    >
        <template #item-content.2>
            <table class="mb2 table-dashboard" width="100%">
                <thead>
                    <tr>
                        <td>Pemilik</td>
                        <td>No. ID</td>
                        <td>No. Tel</td>
                        <td>Jenis Pemilik</td>
                        <td>Alamat 1</td>
                        <td>Alamat 2</td>
                        <td>Alamat 3</td>
                        <td>&nbsp;</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="pemiliks in cukais[0].pemiliks">
                        <td>{{ pemiliks.nama }}</td>
                        <td>{{ pemiliks.no_kp }}</td>
                        <td>{{ pemiliks.no_tel }}</td>
                        <td>&nbsp;</td>
                        <td>{{ pemiliks.alamat_1 }}</td>
                        <td>{{ pemiliks.alamat_2 }}</td>
                        <td>{{ pemiliks.alamat_3 }}</td>
                        <td>iHasil</td>
                    </tr>
                    <tr v-for="pemiliks in pemilikSPTB">
                            <td>{{ pemiliks.PB_NAMAPB1 }}</td>
                            <td>{{ pemiliks.PB_NOPB }}</td>
                            <td>&nbsp;</td>
                            <td>{{ pemiliks.perihal.perihal }}</td>
                            <td>{{ pemiliks.PB_ALAMATR1 }}</td>
                            <td>{{ pemiliks.PB_ALAMATR2 }}</td>
                            <td>{{ pemiliks.PB_ALAMATR3 }}</td>
                            <td>SPTB</td>
                    </tr>
                </tbody>
            </table>
        </template>

        <template #item-content.1>
            <div class="custom-tabs">
                <w-tabs :items="hantarTahun.length" center>
                    <template #item-title="{ index }">
                        <!-- {{hantarTahun[index-1].tahun }} -->
                        {{ hantarTahun[index - 1] }}
                    </template>

                    <template #item-content="{ index }">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Perihal</td>
                                    <td style="text-align: right">
                                        Amaun (RM)
                                    </td>
                                </tr>
                            </thead>
                            <tbody v-for="cukais in cukais">
                                <tr v-for="cua in cukais.cukais">
                                    <td
                                        v-if="
                                            parseFloat(cua.tahun) ==
                                            hantarTahun[index - 1]
                                        "
                                    >
                                        <div v-if="cua.tunggakan_dari != null">
                                            <w-badge class="tahun-tunggakan">
                                                <template #badge
                                                    >{{
                                                        cua.tunggakan_dari
                                                    }}&nbsp;-{{
                                                        cua.tunggakan_hingga
                                                    }}</template
                                                >
                                                {{ cua.keterangan }}
                                            </w-badge>
                                        </div>
                                        <div v-else>
                                            {{ cua.keterangan }}
                                        </div>
                                    </td>

                                    <td
                                        v-if="
                                            parseFloat(cua.tahun) ==
                                            hantarTahun[index - 1]
                                        "
                                        style="text-align: right"
                                    >

                                        <div v-if="cua.amaun_debit != null && cua.amaun_debit > 0">
                                            {{ moneyFormat(cua.amaun_debit) }}
                                        </div>
                                        <div v-if="cua.amaun_kredit != null && cua.amaun_kredit > 0">
                                           (Lebih Bayar) -{{ moneyFormat(cua.amaun_kredit) }}
                                        </div>

                                        <div v-if="cua.amaun_ampun_hasil !=null && cua.amaun_ampun_hasil >0">
                                            (Ampun Hasil) - {{ moneyFormat(cua.amaun_ampun_hasil) }}
                                        </div>
                                        <div v-if="cua.amaun_diskaun !=null && cua.amaun_diskaun >0 && cua.is_diskaun == 1">
                                            (Diskaun) - {{ moneyFormat(cua.amaun_diskaun) }}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span>JUMLAH</span>
                                    </td>
                                    <td class="text-right">
                                        {{ moneyFormat(totalsum(hantarTahun[index - 1])) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <w-alert info xs icon-outside color="primary">
                            Jumlah Perlu Dibayar = Jumlah Amaun - Jumlah Diskaun
                            - Jumlah&nbsp;Remisyen
                        </w-alert>
                        <!-- <p class="mt5 mb5 pl5">
                    </p> -->

                        <table class="table-dashboard" width="100%">
                            <tbody>
                                <tr>
                                    <td>Jumlah Perlu Dibayar</td>
                                    <td width="16%" class="text-right">
                                        {{ moneyFormat(totalsum(hantarTahun[index - 1])) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Jumlah Telah Dibayar&nbsp;</td>
                                    <td class="text-right">
                                        {{ moneyFormat(telahBayar(hantarTahun[index - 1])) }}
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td>Diskaun Cukai Tanah Jan - Mei</td>
                                    <td class="text-right">-5.60</td>
                                </tr> -->
                                <tr>
                                    <td>Baki Perlu Dijelaskan</td>
                                    <td class="text-right">
                                        {{
                                            moneyFormat(
                                                totalsum(
                                                    hantarTahun[index - 1]
                                                ) -
                                                telahBayar(
                                                    hantarTahun[index - 1]
                                                )
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </w-tabs>
            </div>
        </template>

        <template #item-content.3>
            <table
                class="table-dashboard"
                width="100%"

            >
                <thead>
                    <tr>
                        <td width="12%">No. Resit</td>
                        <td width="16%">No Rujukan</td>
                        <td width="16%">Nama Pembayar</td>
                        <td width="14%">Cara Bayar</td>
                        <td width="12%">Amaun (RM)</td>
                        <td width="14%">Bank</td>
                        <td width="20%">Tarikh Bayar</td>
                        <td width="20%">Tarikh Batal</td>
                        <td width="10%">Status</td>
                    </tr>
                </thead>
                <tbody v-for="cukais in cukais">
                    <tr v-for="bayar in cukais.terimaan">
                        <td>{{ bayar.no_resit }}</td>
                        <td>{{ bayar.no_rujukan }}</td>
                        <!-- <td>{{ bayar.nama_pembayar }}</td> -->
                        <td>
                            {{ bayar.nama_pembayar }}
                            <div v-if="bayar.no_tel_pembayar != null">
                                &nbsp;-{{ bayar.no_tel_pembayar }}
                            </div>
                        </td>
                        <td>
                            {{ bayar.cara_bayar }} ({{ bayar.kod_cara_bayar }})
                        </td>
                        <td align="right">{{ moneyFormat(bayar.amaun) }}</td>
                        <td>{{ bayar.bank }}</td>
                        <td>{{ moment(bayar.tarikh).format("DD-MM-YYYY h:mm:ss A"
                                )}}</td>
                        <td>{{bayar.tarikh_batal}}</td>

                        <td>{{ bayar.status }}</td>

                    </tr>
                </tbody>

                <tbody >
                    <tr v-for="bayar in this.sejBayar">
                        <td>{{ bayar.no_resit }}</td>
                        <td>{{ bayar.no_rujukan }}</td>
                        <!-- <td>{{ bayar.nama_pembayar }}</td> -->
                        <td>
                            {{ bayar.nama_pembayar }}
                            <div v-if="bayar.no_tel_pembayar != null">
                                &nbsp;-{{ bayar.no_tel_pembayar }}
                            </div>
                        </td>
                        <td>
                            {{ bayar.cara_bayar }} ({{ bayar.kod_cara_bayar }})
                        </td>
                        <td align="right">{{ moneyFormat(bayar.amaun )}}</td>
                        <td>{{ bayar.bank }}</td>
                        <td>{{ moment(bayar.tarikh_bayar).format("DD-MM-YYYY h:mm:ss A"
                                )}}</td>
                        <td>{{bayar.tarikh_batal}}</td>

                        <td>{{ bayar.status }}</td>

                    </tr>
                </tbody>

            </table>

            <!-- <div class="w-card__content content-hardcode" v-else>
                Tiada Maklumat Berkaitan
            </div> -->
        </template>
        <template #item-content.4>

            <table
                class="table-dashboard"
                width="100%"
                v-if="cukai.mesej && cukai.mesej.length > 0"
            >
                <thead>
                    <tr>
                        <td>Bil</td>
                        <td>Tarikh Mesej</td>
                        <td>Di Hantar Oleh</td>
                        <td>No Fail</td>
                        <td>Catatan</td>
                        <td>Ubah</td>
                    </tr>
                </thead>

                <tbody v-for="cukais in cukais">
                    <tr v-for="mc in cukais.mesej">
                        <td>{{ index+1}}</td>
                        <td>{{ mc.MC_TKHMASUK }}</td>
                        <td>{{ mc.MC_NAMA }}</td>
                        <td>{{ mc.MC_NOFAIL }}</td>
                        <td>{{ mc.Ulasan }}</td>
                        <td>{{ mc.Catatan }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="w-card__content content-hardcode" v-else>
                Tiada Maklumat Berkaitan
            </div>
        </template>

        <template #item-content.5>
            <table
                class="table-dashboard"
                width="100%"
                v-if="cukai.jejak_audits && cukai.jejak_audits.length > 0"
            >
                <thead>
                    <tr>
                        <td width="20%">Nama</td>
                        <td width="20%">Catatan</td>
                        <td width="20%">Keterangan</td>
                        <!-- <td width="20%">Id Kemaskini</td> -->
                        <td width="20%">Tarikh</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="cua in cukais[0].jejak_audits">
                        <td>{{ cua.name }}</td>
                        <td>{{ cua.catatan }}</td>
                        <td>{{ cua.keterangan }}</td>
                        <!-- <td>SISTEM</td> -->
                        <td>{{ cua.created_at }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="w-card__content content-hardcode" v-else>
                Tiada Maklumat Berkaitan
            </div>
        </template>

        <template #item-content.6>
            <table
                class="table-dashboard"
                width="100%"
                v-if="cukai.ampun_hasil && cukai.ampun_hasil.length > 0"
            >
                <thead>
                    <tr>
                        <td>Bil.</td>
                        <td>No. MMK</td>
                        <td>Pemilik</td>
                        <td>Kategori</td>
                        <!-- <td>Amaun Cukai (RM)</td> -->
                        <td>Amaun Remisyen (RM)</td>
                        <!-- <td>Remisyen (%)</td> -->
                        <!-- <td>Baki Amaun Cukai (RM)</td> -->
                        <td>Tempoh Mula</td>
                        <td>Tempoh Tamat</td>
                        <td>Dokumen</td>
                        <td>Status</td>
                    </tr>
                </thead>
                <tbody v-for="cukais in cukais">
                    <tr v-for="(ampunHasil, index) in cukais.ampun_hasil">
                        <td>{{ index + 1 }}</td>
                        <td>{{ ampunHasil.no_tauliah }}</td>
                        <td>{{ ampunHasil.pemilik }}</td>
                        <td>{{ ampunHasil.kategori }}</td>
                        <td>{{ ampunHasil.amaun }}</td>
                        <td>
                            <div v-if="ampunHasil.tarikh_mula!=null">
                                {{moment(ampunHasil.tarikh_mula).format("DD-MM-YYYY")}}
                            </div>
                            <div v-else>
                                Tiada Tarikh Mula
                            </div>
                        </td>
                        <td>
                            <div v-if="ampunHasil.tarikh_tamat!=null">
                                {{moment(ampunHasil.tarikh_tamat).format("DD-MM-YYYY")}}
                            </div>
                            <div v-else>
                               <center>Tiada Tarikh Tamat</center>
                            </div>
                        </td>
                        <td><w-button v-if="ampunHasil.file" @click="dokumen(ampunHasil.file)">
                         <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on"> fal fa-file </w-icon>
                                </template>
                                Papar
                            </w-tooltip></w-button>
                                <h1 v-else>Tiada</h1>
                            </td>
                        <td>{{ ampunHasil.status }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="w-card__content content-hardcode" v-else>
                Tiada Maklumat Berkaitan
            </div>
            <w-flex class="mt2" wrap align-center justify-end v-if="$zutil.can('Cukai Kemaskini')">
                <w-form @submit.prevent="submit">
                    <w-button class="my1 mr0" type="submit">
                        Daftar/Kemaskini
                    </w-button>
                </w-form>
            </w-flex>
        </template>
        <template #item-content.7>
            <table
                class="table-dashboard"
                width="100%"
                v-if="cukai.pengecualian && cukai.pengecualian.length > 0"
            >
                <thead>
                    <tr>
                        <td>Id</td>
                        <td>No MKNK</td>
                        <td>Tarikh Mula</td>
                        <!-- <td width="20%">Id Kemaskini</td> -->
                        <td>Amaun</td>
                        <!-- <td>Status</td> -->
                    </tr>
                </thead>
                <tbody v-for="cukais in cukais">
                    <tr v-for="cua in cukais.pengecualian">
                        <!-- <div v-if="cua.length !='0'"> -->
                        <td>{{ cua.id }}</td>
                        <td>{{ cua.no_mknk }}</td>
                        <td v-if=(cua.tarikh_mula)>
                            {{ moment(cua.tarikh_mula).format("DD-MM-YYYY") }}
                        </td>
                        <td v-else>
                            Tiada
                        </td>
                        <td>{{ cua.amaun }}</td>
                        <!-- <td>{{ cua.status }}</td> -->
                        <!-- </div> -->
                    </tr>
                </tbody>
            </table>
            <div class="w-card__content content-hardcode" v-else>
                Tiada Maklumat Berkaitan
            </div>
            <w-flex class="mt2" wrap align-center justify-end v-if="$zutil.can('Cukai Kemaskini')">
                <w-form @submit.prevent="submitPengecualian">
                    <w-button class="my1 mr0" type="submit">
                        Daftar/Kemaskini
                    </w-button>
                </w-form>
            </w-flex>

        </template>
        <template #item-content.8>
             <table
                class="table-dashboard"
                width="100%"
                v-if="cukai.penguatkuasaan && cukai.penguatkuasaan.length > 0"
            >
                <thead>
                    <tr>
                        <td>Id</td>
                        <td>Jenis Notis</td>
                        <td>No. Notis</td>
                        <td>No. Fail</td>
                        <!-- <td width="20%">Id Kemaskini</td> -->
                        <td>Tarikh Janaan</td>
                        <td>Tindakan</td>
                    </tr>
                </thead>
                <tbody v-for="cukais in cukais">
                    <tr v-for="cua in cukais.penguatkuasaan">
                        <!-- <div v-if="cua.length !='0'"> -->
                        <td>{{ cua.id }}</td>
                        <td>{{ cua.jenis }}</td>
                        <td>{{ cua.no_notis }}</td>
                        <td>{{ cua.no_fail }}</td>
                        <td>
                            {{ moment(cua.janaan[0].tarikh_janaan).format("DD-MM-YYYY") }}
                            </td>

                        <td>{{ cua.status }}</td>
                        <!-- </div> -->
                    </tr>
                </tbody>
            </table>
            <div class="w-card__content content-hardcode" v-else>
                Tiada Maklumat Berkaitan
            </div>
        </template>
        <template #item-content.9>
            <div class="w-card__content content-hardcode">
                Tiada Maklumat Berkaitan
            </div>
            <w-flex class="mt2" wrap align-center justify-end v-if="$zutil.can('Cukai Kemaskini')">
                <w-form @submit.prevent="submitDiskaun">
                    <w-button class="my1 mr0" type="submit">
                        Daftar/Kemaskini
                    </w-button>
                </w-form>
            </w-flex>
        </template>
    </w-tabs>

</template>

<script>
import _ from "lodash";
import { moneyFormat } from "../CukaiTanah/helper/index.js";
import moment from "moment";
import ZResource from "@/Modules/z-resource";
export default {
    extends: ZResource,
    props: {
        items: [Object, Array],
        cukai: [Object, Array],
        cukais: [Object, Array],
        sejBayar:[Object, Array],
    },

    data() {
        return {
            resourceurl: "cukai-tanah",
            reload: true,
            tambahMesej:false,
              apiBaseUrl: process.env.MIX_API_BASE_URL,
            resultTabs: [
                { title: "Butiran Cukai", content: "" },
                { title: "Pemilik", content: "" },
                { title: "Rekod Bayaran", content: "" },
                { title: "Mesej", content: "" },
                { title: "Jejak audit", content: "" },
                { title: "Ampun Hasil", content: "" },
                { title: "Pengecualian", content: "" },
                { title: "Penguatkuasaan", content: "" },
                { title: "Diskaun", content: "" },
            ],
            activeTab: 0,
            tabTahun: [
                { title: "Tiada Cukai", content: "Tiada Cukai" },
                { title: "Tiada Cukai", content: "Tiada Cukai" },
                { title: "Tiada Cukai", content: "Tiada Cukai" },
                { title: "Tiada Cukai", content: "Tiada Cukai" },
                { title: "Tiada Cukai", content: "Tiada Cukai" },
                // { title: "Butiran Cukai", content: "" },
                // { title: "Rekod Bayaran", content: "" },
            ],
            pengecualian: true,
            mesejCukai:[],
            pemilikSPTB:[],
        };
    },
    methods: {
        async pemilikanSPTB(){
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/pemilik`,
                responseType: "json",
                params:{
                    no_hm:this.cukais[0].no_hm
                },
            }).then((e)=>{
                this.pemilikSPTB=e.data;
            });
        },
        dokumen(file){
            // console.log(file);
            var url1 = `${this.apiBaseUrl}/cukai/ampun-hasil/dokumenShow?file=${file}`;
            window.open(url1,"_blank");
        },
        submitDiskaun() {
            window.location.href = `/cukai-tanah/senaraiDiskaun?no_hm=${this.cukais[0].no_hm}`;
        },

        submit() {
            window.location.href = `/cukai-tanah/ampunHasil?no_hm=${this.cukais[0].no_hm}`;
        },
        submitPengecualian() {
            window.location.href = `/cukai-tanah/pengecualian?no_hm=${this.cukais[0].no_hm}`;
        },

        totalsum(tahun) {
            const data = this.cukai.cukais;
            let sum = 0;

            for (let i = 0; i < this.hantarTahun.length; i++) {
                let y = data.length;
                let u = 0;
                while (u < y) {
                    const debit = data[u].amaun_debit;
                    const kredit = data[u].amaun_kredit;
                    const ampunHasil =data[u].amaun_ampun_hasil;
                    const diskaun = data[u].amaun_diskaun;

                    if (
                        kredit == null ||
                        kredit == "NaN" ||
                        kredit == "undefiend"
                    ) {
                        var kredit1 = 0;
                    } else {
                        var kredit1 = parseFloat(kredit);
                    }

                    if (
                        debit == null ||
                        debit == "NaN" ||
                        debit == "undefiend"
                    ) {
                        var debit1 = 0;
                    } else {
                        var debit1 = parseFloat(debit);
                    }

                    if (
                        ampunHasil == null ||
                        ampunHasil == "NaN" ||
                        ampunHasil == "undefiend"
                    ) {
                        var ampunHasil1 = 0;
                    } else {
                        var ampunHasil1 = parseFloat(ampunHasil);
                    }

                    if (
                        diskaun == null ||
                        diskaun == "NaN" ||
                        diskaun == "undefiend" || 
                        data[u].is_diskaun != 1
                    ) {
                        var diskaun1 = 0;
                    } else {
                        var diskaun1 = parseFloat(diskaun);
                    }

                    if (
                        data[u].tahun == this.hantarTahun[i] &&
                        data[u].tahun == tahun
                    ) {
                        // total=;
                        sum = debit1 - kredit1  - ampunHasil1 - diskaun1 + sum;
                    }
                    // console.log(kredit1);
                    u++;
                }
            }
            return sum.toFixed(2);
            //   return sum;
        },
         telahBayar(tahun) {
            const data = this.cukai.terimaan;
            const getYear = this.cukai.tahun || '';
            let sum = 0;

            let y = data.length;
            let u = 0;
            while (u < y) {
                if (data[u].tahun_bayar == tahun){
                    const resit = data[u].amaun;
                    const status = data[u].kod_status;

                    if (resit == null || resit == "NaN" || resit == "undefiend") {
                        var resit1 = 0;
                    } else {
                        if (status == 'K'){
                            var resit1 = parseFloat(resit);
                        }
                        else{
                            var resit1=0;
                        }
                    }
                    sum = resit1 + sum;
                }
                u++;
            }

            return sum.toFixed(2);
            //   return sum;
        },
        moneyFormat
        // formatDuit(v){
        //     return moneyFormat(v)
        // },
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
        hantarTahun() {
            var _ = require("lodash");
            const tab = this.cukai.cukais;

            // console.log(_.uniqBy(tab,"tahun"));
            // console.log(_.sortBy(_.uniqBy(tab,"tahun"),'date'));
            const x = _.uniqBy(tab, "tahun");
            const y = [];
            for (let i = 0; i < x.length; i++) {
                const p = parseFloat(x[i].tahun);
                y.push(p);
            }
            y.sort(function (a, b) {
                return b - a;
            });
            // console.log(tab);
            return y;
        },

        newYear() {
            const d = new Date();
            let c = d.getFullYear();

            return c;
        },
    },
    mounted(){
        this.pemilikanSPTB();
    }
};
</script>
<style>
.custom-tabs > .w-tabs {
    border: none !important;
}

.tahun-tunggakan > .w-badge {
    margin-left: 10px;
    padding: 0 10px 0 10px;
}
</style>
